import * as React from 'react';
import './consent.css';

// The consent sheet, shown on every load until the user accepts: what the
// app sends and to whom, Accept, and Not now (gone for this load, back on
// the next). Presentational: the entry point decides when it shows and what
// the buttons do. `aria-modal="false"`: the app behind stays usable, and
// Escape does nothing special.

export interface ConsentOverlayProps {
  brandName: string;
  onAccept(): void;
  onDismiss(): void;
}

export const ConsentOverlay: React.FC<ConsentOverlayProps> = ({ brandName, onAccept, onDismiss }) => {
  const titleId = React.useId();
  return (
    <div className="consent" role="dialog" aria-labelledby={titleId} aria-modal="false">
      <h2 id={titleId} className="consent-title">
        Help improve {brandName}
      </h2>
      <p className="consent-text">
        {brandName} sends anonymous usage data to Google Analytics: which screens and buttons are used, never your games, your username or your moves. You can
        decline and the app works the same.
      </p>
      <div className="consent-actions">
        <button type="button" className="btn" onClick={onDismiss}>
          Not now
        </button>
        <button type="button" className="btn btn-primary" data-track="consent.accept" onClick={onAccept}>
          Accept
        </button>
      </div>
    </div>
  );
};
